import privacyPolicyPdf from '../documents/2026  - Informativa Privacy.pdf'
import cookiePolicyPdf from '../documents/2026 - Cookie police.pdf'

export const POLICY_DOCUMENTS = {
  privacy: privacyPolicyPdf,
  cookie: cookiePolicyPdf,
}
